// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7945) return "static/chunks/7945-8483bd2345200977.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "6593eb6f3d3d9226" + ".js";
};